import { KeyValueValidatorModel } from '../models/misc/key-value/key-value-validator.model';
import { Const } from './Const';
import {
    KeyValueDefinitionModel,
    KeyValueItemDefinitionModel,
} from '../models/misc/key-value/key-value-definition.model';

export class KeyValueDefinitions {
    public static LabelsDefinition = new KeyValueDefinitionModel({
        key: new KeyValueItemDefinitionModel({
            placeholder: 'Enter a label key',
            validators: [
                new KeyValueValidatorModel({
                    state: 'error',
                    message:
						'Label key can only be lowercase alphabetical letters (a-z), numbers (0-9), hyphens (-), and periods (.), and must start and end with a lowercase letter or number',
                    regex: Const.LABEL_KEY_EXP,
                }),
                new KeyValueValidatorModel({
                    state: 'error',
                    message:
                  'Can only be 63 characters',
                    regex: Const.LABEL_KEY_LENGTH,
                }),
            ],
        }),
        value: new KeyValueItemDefinitionModel({
            placeholder: 'Enter a label value (optional)',
            validators: [
                new KeyValueValidatorModel({
                    state: 'error',
                    message:
						'Label value can only be lowercase alphabetical letters (a-z), numbers (0-9), underscores (_), hyphens (-), and periods (.), and must start and end with a lowercase letter or number',
                    regex: Const.LABEL_VALUE_EXP,
                }),
            ],
        }),
        duplicateKeyMessage: 'Label has already been added; change the name or remove this row',
        emptyKeyMessage: 'Provide a label name or remove this row',
        addButtonTooltip: 'Add Label',
        removeButtonTooltip: 'Remove Label',
    });
    public static AnnotationsDefinition = new KeyValueDefinitionModel({
        key: new KeyValueItemDefinitionModel({
            placeholder: 'Enter an annotation key',
            validators: [
                new KeyValueValidatorModel({
                    state: 'error',
                    message:
						'Annotation key can only be lowercase alphabetical letters (a-z), numbers (0-9), hyphens (-), and must start and end with a lowercase letter or number',
                    regex: Const.ANNOTATION_KEY_EXP,
                }),
                new KeyValueValidatorModel({
                    state: 'error',
                    message:
                  'Can only be 63 characters',
                    regex: Const.LABEL_KEY_LENGTH,
                }),
            ],
        }),
        value: new KeyValueItemDefinitionModel({
            placeholder: 'Enter an annotation value (optional)',
            validators: [],
        }),
        duplicateKeyMessage: 'Annotation has already been added; change the name or remove this row',
        emptyKeyMessage: 'Provide an annotation name or remove this row',
        addButtonTooltip: 'Add Annotation',
        removeButtonTooltip: 'Remove Annotation',
    });
}
